import React, { Component } from "react"
import IndexRouter from "./router"
import { withRouter } from "react-router-dom"
import { LocaleProvider } from 'antd'
import enUS from 'antd/lib/locale-provider/en_US'
import $Header from "./components/Header"
import $Menu from "./components/Menu"
import styled from "styled-components"
import request from '@/utils/request'
import { Spin } from 'antd'

const Root = styled.div`
  /* display: grid; */
`

const Main = styled.div`
  position:relative;
  margin-left:230px;
  margin-top:70px;  
  background-color:#f4f5f9;
  padding:20px;
`

const Header = styled($Header)`
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:70px;
  box-shadow: 0 1px 4px 0 rgba(0,21,41,.12);
  background-color:#ffffff;
  z-index:100;
`
const Menu = styled($Menu)`
  position: fixed;
  top:70px;
  left:0;
  width:230px;
  height:calc(100vh - 70px);
`

const Contain = styled.div`
  background-color:#ffffff;
`

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tokenFetched:false
    };
  }
  componentDidMount() {
    this.getToken()
  }
  getToken(){
    request.get('/api/user/getToken').then((res)=>{
      if(res&&!res.code){
        sessionStorage.setItem('lockcard_token',res.info)
      }
      this.setState({tokenFetched:true})
    })
  }
  render() {
    const {tokenFetched}=this.state
    const {location}=this.props
    return (
      <Spin spinning={!tokenFetched}>
        <Root>
          {
            tokenFetched&&(
              <div>
                <Header />
                <Main>
                  <Contain>
                    <IndexRouter />
                  </Contain>
                </Main>
                <Menu pathname={location.pathname}/>
              </div>
            )
          }
        </Root>
      </Spin>
    )
  }
}

export default withRouter(props=><LocaleProvider locale={enUS}><App {...props}></App></LocaleProvider>)
